import { openModal, closeModal } from "./modal.js";

const header = document.querySelector("[data-site-header]");
const menu = document.querySelector("#main-navigation");
const hamburger = document.querySelector("#hamburger");
const openIcon = hamburger.querySelector(".menuIcon");
const closeIcon = hamburger.querySelector(".closeIcon");

let navOpen = false;

// Toggle nav
hamburger.addEventListener("click", function () {
  navOpen ? closeNav() : openNav();
});

// Close nav when a link is clicked
menu.addEventListener("click", function (event) {
  if (event.target.tagName === "A") {
    closeNav();
  }
});

const openNav = () => {
  navOpen = true;
  openModal();

  header.classList.add("open");
  menu.classList.remove("hidden");
  menu.classList.add("block", "opacity-100");
  openIcon.classList.add("hidden");
  closeIcon.classList.remove("hidden");
};

const closeNav = () => {
  navOpen = false;
  closeModal();

  header.classList.remove("open");
  menu.classList.add("hidden");
  menu.classList.remove("block", "opacity-100");
  openIcon.classList.remove("hidden");
  closeIcon.classList.add("hidden");
};

window.onresize = () => {
  if (window.innerWidth >= 1020 && navOpen) {
    closeNav();
  }
};

export { openNav, closeNav };
